<template>

  <div class="orders">
        <template>
          <v-row justify="center">
            <OrderDetail @updateDialogShow="updateDialogShow" v-bind:selectedElement="selectedElement" v-bind:dialog="dialog"></OrderDetail>
          </v-row>  
        </template>
        <v-card v-if="elements.length == 0">
          <v-card-subtitle>
          <span><center>No existen pedidos que preparar</center></span>
          </v-card-subtitle>
        </v-card>
        <v-list three-line v-if="elements.length > 0">
          <template v-for="(item, index) in elements">
            <v-subheader
                    v-if="item.header"
                    :key="item.header"
                    v-text="item.header"
            ></v-subheader>

            <v-divider
                    v-else-if="item.divider"
                    :key="index"
                    :inset="item.inset"
            ></v-divider>

            <v-list-item
                    v-else
                    :key="item.title"
                    @click="openItem(item)"
            >
              <v-list-item-avatar>
                <v-img :src="item.avatar"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-html="item.user"></v-list-item-title>
                <v-list-item-subtitle v-html="item.address"></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content style="margin-left: 20px">
                <v-list-item-subtitle>A {{ item.haversine.toFixed(2) }} km</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon style="margin-right: 30px; margin-left: -30px">
                  <v-icon v-if="item.fromVoiceAssistant">mdi-account-voice</v-icon>
              </v-list-item-icon>
              <v-list-item-icon style="margin-left: -20px">
                <v-icon v-if="!item.isDelivered">mdi-truck-delivery</v-icon>
              </v-list-item-icon>
              <v-list-item-icon style="margin-left: -24px;">
                <v-icon v-if="item.isDelivered">mdi-truck-check</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
        </v-list>

        <v-btn @click="addOrder"
            style="margin-bottom: 78px"
            color="pink"
            dark
            absolute
            bottom
            right
            fab
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>

  </div>
</template>

<script>
// @ is an alias to /src
import OrderDetail from '../components/OrderDetail'
import { DB } from '../firebase/db';
import haversine from 'haversine';

var moment = require('moment');
moment.locale('es')

export default {
  name: 'orders',

  props:['date'],

  data: () => ({
      title: 'Pedidos',
      realtimeUnsub : undefined,
      loading: true,
      elements: [],
      dialog: false,
      selectedElement : {},
      selectedElementIndex: -1
    }),

    components : {
      OrderDetail
    },

    created () {
      this.$emit('updateTitle', this.title);
      this.getOrders();
    },

    watch : {
      date : function() {
        this.getOrders();
      }
    },

    methods: {

      getOrders() {

        if(this.realtimeUnsub != undefined){
          this.realtimeUnsub();
        }

        this.elements.splice(0);

        this.realtimeUnsub = DB.collection('orders').where('date', '==', this.date)
        .onSnapshot( snapshots => {

          snapshots.docChanges().forEach( change => {

            const item = change.doc;
            let element = {
              formattedDate : moment(item.data().date).format("DD-MM-YYYY"),
              date : item.data().date,
              isDelivered : item.data().isDelivered,
              user : item.data().user,
              products : item.data().products,
              firebaseId: item.id,
              id : item.data().id,
              location: item.data().location,
              avatar: item.data().userPhoto,
              address: item.data().address,
              fromVoiceAssistant: item.data().fromVoiceAssistant
            }
            
            switch (change.type) {
              case "added":
                this.elements.push(element);   
                break;

              case "modified":
                for (let i = 0; i < this.elements.length; i++) {
                  if(this.elements[i].id == item.id)
                  {
                    this.elements[i] = { ...element }
                    break;
                  }
                }
                break;

              case "removed":
                for (let i = 0; i < this.elements.length; i++) {
                  if(this.elements[i].id == item.id)
                  {
                    this.elements.splice(i, 1);
                    break;
                  }
                }
                break;
            }

          })

          var self = this;

          navigator.geolocation.getCurrentPosition( position => {
            const currentPosition = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            }

            self.elements.forEach( order => {
              order['haversine'] = haversine(currentPosition, {latitude: order.location.lat, longitude: order.location.lng})
            });

            this.elements.sort((a, b) => {
              return a.haversine - b.haversine;
            });
          })
            
          this.loading = false;
        })
      },

      openItem(element) {
        this.selectedElement = element;
        this.selectedElementIndex = this.elements.indexOf(element);
        this.dialog = true;
      },

      updateDialogShow(show) {
        this.dialog = show;
      },

      addOrder() {
          this.$router.push(`/create-order/${this.date}`)
      }
    }
}
</script>